import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import SystemRole from './system-role-model'
import {
  CreateSystemRoleAsync,
  DeleteSystemRoleAsync,
  LoadSystemRolesAsync,
} from './systemRole-thunk'
const initialState: systemRoleSliceState = {
  systemRole: [],
  selected_systemRole: '',
  is_loading_systemRole: false,
  is_creating_systemRole: false,
  is_deleting_systemRole: false,
}
export interface systemRoleSliceState {
  systemRole: SystemRole[]
  selected_systemRole?: string
  is_loading_systemRole: boolean
  is_creating_systemRole: boolean
  is_deleting_systemRole: boolean
}
export const systemRoleSlice = createSlice({
  name: 'systemRole',
  initialState,
  reducers: {
    setSelectedsystemRole: (state, action) => {
      state.selected_systemRole = action.payload
    },
    clearStatesystemRole: (state) => {
      state.systemRole = []
      state.is_loading_systemRole = false
      state.is_creating_systemRole = false
      state.is_deleting_systemRole = false
    },
    mergesystemRole: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_systemRole = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.systemRole = merge(state.systemRole, payload) as any
        }
      }
    },

    add_systemRole: (state, action) => {
      if (action.payload) {
        state.systemRole = [...state.systemRole, action.payload]
      }
    },
    set_systemRole: (state, action) => {
      let { key, value, id } = action.payload
      state.systemRole = state.systemRole.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadSystemRolesAsync.pending, (state) => {
      state.is_loading_systemRole = true
    })
    builder.addCase(LoadSystemRolesAsync.fulfilled, (state, action) => {
      state.is_loading_systemRole = false
      if (action.payload) {
        state.systemRole = action.payload
      }
    })
    builder.addCase(LoadSystemRolesAsync.rejected, (state) => {
      state.is_loading_systemRole = false
    })
    builder.addCase(CreateSystemRoleAsync.pending, (state) => {
      state.is_creating_systemRole = true
    })
    builder.addCase(CreateSystemRoleAsync.fulfilled, (state) => {
      state.is_creating_systemRole = false
    })
    builder.addCase(CreateSystemRoleAsync.rejected, (state) => {
      state.is_creating_systemRole = false
    })
    builder.addCase(DeleteSystemRoleAsync.pending, (state) => {
      state.is_deleting_systemRole = true
    })
    builder.addCase(DeleteSystemRoleAsync.fulfilled, (state, action) => {
      state.is_deleting_systemRole = false
      if (state.systemRole) {
        state.systemRole = state.systemRole.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteSystemRoleAsync.rejected, (state) => {
      state.is_deleting_systemRole = false
    })
  },
})

export const {
  clearStatesystemRole,
  setSelectedsystemRole,
  set_systemRole,
  mergesystemRole,
  add_systemRole,
} = systemRoleSlice.actions

export const get_systemRole =
  (id?: string) =>
  (state: {
    systemRole: {
      systemRole: SystemRole[]
    }
  }): SystemRole | null => {
    let temp = state?.systemRole?.systemRole?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.systemRole?.systemRole[0] || null
  }
export const get_selected_systemRole = (state: {
  systemRole: systemRoleSliceState
}): SystemRole | null => {
  let id = state?.systemRole?.selected_systemRole
  let temp = state?.systemRole?.systemRole?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_systemRole = (state: {
  systemRole: {
    systemRole: SystemRole[]
  }
}): SystemRole[] => {
  let temp = state?.systemRole?.systemRole
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_systemRole_busy = (state: {
  systemRole: systemRoleSliceState
}) => {
  return (
    state?.systemRole.is_deleting_systemRole ||
    state?.systemRole.is_loading_systemRole ||
    state?.systemRole.is_creating_systemRole
  )
}
export const is_deleting_systemRole_busy = (state: {
  systemRole: systemRoleSliceState
}) => {
  return state?.systemRole.is_deleting_systemRole
}
export const is_loading_systemRole_busy = (state: {
  systemRole: systemRoleSliceState
}) => {
  return state?.systemRole.is_loading_systemRole
}
export const is_creating_systemRole_busy = (state: {
  systemRole: systemRoleSliceState
}) => {
  return state?.systemRole.is_creating_systemRole
}

export default systemRoleSlice.reducer
